import React from 'react';
import AppRouter from './routes/AppRouter';
// import 'normalize.css';
import './assets/css/index.css';
import { Provider } from 'react-redux';
import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient();

function App() {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <QueryClientProvider client={queryClient}>
                    <AppRouter />
                    <ReactQueryDevtools />
                </QueryClientProvider>
            </PersistGate>
        </Provider>
    );
}

export default App;
